export type RuntimeCandidate = {
  id: "native-browser" | "nodepod" | "webcontainer" | "almostnode";
  label: string;
  packageName: string;
  architecture: string;
  browserSupport: string;
  virtualHttp: boolean;
  npmInstall: boolean;
  snapshot: boolean;
  licenseStatus: "verify-before-distribution" | "user-provided";
  status: "implemented" | "optional-benchmark";
};

export const RUNTIME_CANDIDATES: RuntimeCandidate[] = [
  {
    id: "native-browser",
    label: "Native browser backend",
    packageName: "none",
    architecture: "Web Worker + IndexedDB + Fetch Request/Response",
    browserSupport: "Modern browsers with Web Workers and IndexedDB",
    virtualHttp: true,
    npmInstall: false,
    snapshot: true,
    licenseStatus: "verify-before-distribution",
    status: "implemented",
  },
  {
    id: "nodepod",
    label: "Nodepod",
    packageName: "@r1ck404/nodepod",
    architecture: "Browser-native Node runtime with Service Worker virtual HTTP",
    browserSupport: "Modern browsers; verify Service Worker constraints",
    virtualHttp: true,
    npmInstall: true,
    snapshot: true,
    licenseStatus: "verify-before-distribution",
    status: "optional-benchmark",
  },
  {
    id: "webcontainer",
    label: "WebContainer API",
    packageName: "@webcontainer/api",
    architecture: "StackBlitz browser Node runtime",
    browserSupport: "Chromium-first; cross-origin isolation required for full mode",
    virtualHttp: true,
    npmInstall: true,
    snapshot: false,
    licenseStatus: "verify-before-distribution",
    status: "optional-benchmark",
  },
  {
    id: "almostnode",
    label: "almostnode",
    packageName: "almostnode",
    architecture: "Node API shims with virtual filesystem and Service Worker",
    browserSupport: "Modern browsers; experimental",
    virtualHttp: true,
    npmInstall: true,
    snapshot: false,
    licenseStatus: "verify-before-distribution",
    status: "optional-benchmark",
  },
];
